// @flow
import { CategoriasActionTypes } from './constants';

// import { APICore } from '../../helpers/api/apiCore';

// const api = new APICore();

const INIT_STATE = {
    categoria: {},
    listaCategorias: [],
    loading: false,
    loadingForm: false,
    error: false,
    formSubmited: false
};

type CategoriasAction = {
    type: string,
    payload: { actionType?: string, data?: any, error?: string },
};
type State = { categoria?: {} | null, listaCategorias?: [] | null, loading?: boolean, +value ?: boolean };

const Categorias = (state: State = INIT_STATE, action: CategoriasAction): any => {
    // console.log(action);
    switch (action.type) {
        case CategoriasActionTypes.API_RESPONSE_SUCCESS:
            switch (action.payload.actionType) {
                case CategoriasActionTypes.GET_CATEGORIA: {
                    return {
                        ...state,
                        categoria: action.payload.data,
                        error: false,
                        loading: false,
                    };
                }
                case CategoriasActionTypes.LIST_CATEGORIAS: {
                    return {
                        ...state,
                        listaCategorias: action.payload.data,
                        error: false,
                        loading: false,
                    };
                }
                case CategoriasActionTypes.ADD_CATEGORIA: {
                    return {
                        ...state,
                        error: false,
                        loadingForm: false,
                        formSubmited: true
                    };
                }
                case CategoriasActionTypes.UPDATE_CATEGORIA: {
                    return {
                        ...state,
                        error: false,
                        loadingForm: false,
                        formSubmited: true
                    };
                }
                case CategoriasActionTypes.DELETE_CATEGORIA: {
                    return {
                        ...state,
                        error: false,
                        loading: false,
                        formSubmited: true
                    };
                }
                default:
                    return { ...state };
            }

        case CategoriasActionTypes.API_RESPONSE_ERROR:
            switch (action.payload.actionType) {
                case CategoriasActionTypes.GET_CATEGORIA: {
                    return {
                        ...state,
                        error: action.payload.error,
                        categoria: {},
                        loading: false,
                    };
                }
                case CategoriasActionTypes.LIST_CATEGORIAS: {
                    return {
                        ...state,
                        error: action.payload.error,
                        listaCategorias: [],
                        loading: false,
                    };
                }
                case CategoriasActionTypes.ADD_CATEGORIA: {
                    return {
                        ...state,
                        error: action.payload.error,
                        loadingForm: false,
                        formSubmited: true
                    };
                }
                case CategoriasActionTypes.UPDATE_CATEGORIA: {
                    return {
                        ...state,
                        error: action.payload.error,
                        loadingForm: false,
                        formSubmited: true
                    };
                }
                case CategoriasActionTypes.DELETE_CATEGORIA: {
                    return {
                        ...state,
                        error: action.payload.error,
                        loading: false,
                        formSubmited: true
                    };
                }
                default:
                    return { ...state };
            }

        case CategoriasActionTypes.GET_CATEGORIA:
            return { ...state, error: false, loading: true };
        case CategoriasActionTypes.LIST_CATEGORIAS:
            return { ...state, error: false, loading: true };
        case CategoriasActionTypes.ADD_CATEGORIA:
            return { ...state, error: false, loadingForm: true };
        case CategoriasActionTypes.UPDATE_CATEGORIA:
            return { ...state, error: false, loadingForm: true };
        case CategoriasActionTypes.DELETE_CATEGORIA:
            return { ...state, error: false, loading: true };
        case CategoriasActionTypes.RESET:
            return {
                ...state,
                loading: false,
                loadingForm: false,
                error: false,
                categoria: {},
                listaCategorias: [],
                formSubmited: false
            };
        default:
            return { ...state };
    }
};

export default Categorias;
